module.exports = __webpack_public_path__ + "static/img/email.0088ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/email.png
// module id = 986
// module chunks = 33